import React from 'react';
import { icons, Button } from '@ublend-npm/aulaui-next';
import { isAndroid, isIOS, isMobile } from '../../utils/mobileUtils';

import { AppStoreLogo, PlayStoreLogo } from '../StoreLogos';

import {
  Container,
  SuccessMessageContainer,
  SuccessMessageText,
  WelcomeMessageContainer,
  WelcomeMessageText,
  StoreLogosContainer,
  StoreMessageContainer,
  StoreMessageText,
} from './SuccessMessage.styled';
import { getInstitutionURL } from '../../utils/getInstitution';
import { windowUtils } from '../../utils/windowUtils';

const renderStoreLogo = () => {
  if (isMobile()) {
    if (isAndroid()) {
      return <PlayStoreLogo />;
    }
    if (isIOS()) {
      return <AppStoreLogo />;
    }
  }
  return (
    <>
      <PlayStoreLogo />
      <AppStoreLogo />
    </>
  );
};

type SuccessMessageProps = {
  spaceName: string;
  spaceId: string;
};

export const SuccessMessage = ({ spaceName, spaceId }: SuccessMessageProps) => (
  <Container>
    <SuccessMessageContainer>
      <icons.CheckCircle />
      <SuccessMessageText>Sign-up successful</SuccessMessageText>
    </SuccessMessageContainer>
    <WelcomeMessageContainer>
      <WelcomeMessageText>
        Welcome to &quot;{spaceName}&quot; on Aula!
      </WelcomeMessageText>
      {!isMobile() && (
        <div>
          <Button
            onClick={() => windowUtils.open(getInstitutionURL(spaceId))}
            type="primary"
          >
            Continue to Aula
          </Button>
        </div>
      )}
    </WelcomeMessageContainer>
    <StoreMessageContainer>
      <StoreMessageText>
        Get the Aula mobile app and easily access your course from anywhere:
      </StoreMessageText>
      <StoreLogosContainer>{renderStoreLogo()}</StoreLogosContainer>
    </StoreMessageContainer>
  </Container>
);
